import React from 'react';
import { SertificationItem } from './CetificationItem';

const Certifications = ({ data }) => {
  return data.certifications &&
    data.certifications.enable &&
    data.certifications.items.filter((x) => x.enable).length > 0 ? (
    <div className="mb-6">
      <div className="mb-1 mt-3 font-bold tracking-wide" style={{ fontSize: 14 }}>
        {data.certifications.heading}
      </div>
      <ul>{data.certifications.items.map(SertificationItem)}</ul>
    </div>
  ) : null;
};

export default Certifications;
